import { render, staticRenderFns } from "./getParkingCoupon.vue?vue&type=template&id=42661f12&scoped=true"
import script from "./getParkingCoupon.vue?vue&type=script&lang=js"
export * from "./getParkingCoupon.vue?vue&type=script&lang=js"
import style0 from "./getParkingCoupon.vue?vue&type=style&index=0&id=42661f12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42661f12",
  null
  
)

export default component.exports